export default __webpack_public_path__ + "static/media/img-3-d-map-120-80@3x.ae9739bc.png";